import { useMemo, useState } from 'react'

import { errorHandler } from '../../../../../../services/util/error.service'
import AgendamentosEntregaHttp from '../../../../../../services/api/https/deliveries/agendamentos-entrega.http'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  LOADING_EDIT: 'Adquirindo informações',
  SAVE_UPDATE: 'Atualizando agendamentos',
  SUCCESS: 'Agendamento cadastrado',
}

const FIELD_ERRORS_MESSAGE = {
  deliveried_date: 'O campo Razão Social precisa ser preenchido',
}

export const INITIAL_STATE = {
  data: {
    date: null,
    id: null,
    delivery_id: null,
  },
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useModalAgendamento() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    const throwError = fieldName =>
      setState(prevState => ({ ...prevState, errorMessage: FIELD_ERRORS_MESSAGE[fieldName] }))

    const fieldIsValid = field =>
      field && field !== 0 && (typeof field === 'string' ? field.trim() !== '' : true)

    const areFieldsValid = ({ date }) => {
      const fields = { date }
      let fieldsNames = Object.keys(fields)
      return fieldsNames.every(fieldName => {
        if (!fieldIsValid(fields[fieldName])) {
          throwError(fieldName)
          return false
        }
        return true
      })
    }

    return {
      // Actions
      saveUpdateAgendamento(agendamento) {
        AgendamentosEntregaHttp.save(agendamento)
          .then(agendamento =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.SUCCESS,
              data: agendamento,
            })),
          )
          .catch(err => setState(prevState => ({ ...prevState, errorMessage: errorHandler(err) })))
      },

      resetState() {
        setState(prevState => ({
          ...prevState,
          ...INITIAL_STATE,
        }))
      },

      resetError() {
        setState(prevState => ({
          ...prevState,
          errorMessage: null,
          loadingMessage: LOAD_MESSAGE.NONE,
        }))
      },

      // Events
      onInit(data) {
        setState(prevState => {
          prevState = { ...INITIAL_STATE }
          prevState.data = data
          prevState.loadingMessage = LOAD_MESSAGE.NONE
          return { ...prevState }
        })
      },

      onInputChange(name, value) {
        setState(prevState => {
          prevState.data[name] = value
          return { ...prevState }
        })
      },

      onBtnSalvarClicked(agendamento) {
        if (areFieldsValid(agendamento)) {
          setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SAVE_UPDATE }))
        }
      },
    }
  }, [])

  return { state, localDispatch }
}
